"use client"

import localEvents from '../events.json'

type EventsData = { EventName: string; Version: string }[]

function buildEventVersionMap(data: EventsData): Record<string, string> {
  return Object.fromEntries(
    data.map(({ EventName, Version }) => [EventName, Version])
  )
}

export let eventVersionMap: Record<string, string> = buildEventVersionMap(localEvents)

export function updateEventVersionMap(data: EventsData): void {
  eventVersionMap = buildEventVersionMap(data)
}

// `versionsReady` resolves once the remote event versions have been loaded (or
// the load has failed/timed out and we are falling back to the bundled values).
// Version-sensitive events that fire early — consent_updated, identity events —
// await this so they don't emit with the stale bundled versions before the
// remote assets fetch has resolved. It never rejects: consumers always proceed.
let resolveVersionsReady: () => void = () => {}
export const versionsReady: Promise<void> = new Promise<void>((resolve) => {
  resolveVersionsReady = resolve
})

export function markVersionsReady(): void {
  resolveVersionsReady()
}
